
export default function debounce<T extends (...args: any[]) => void>(
    callback: T,
    debounceDelay: number = 300,
    immediate: boolean = false
) {
    let timeout: ReturnType<typeof setTimeout> | null;

    return function <U>(this: U, ...args: Parameters<typeof callback>) {
        const context = this;

        if (immediate && !timeout) {
            callback.apply(context, args)
        }

        if (typeof timeout === "number") {
            clearTimeout(timeout);
        }
        timeout = setTimeout(() => {
            timeout = null;
            if (!immediate) {
                callback.apply(context, args)
            }
        }, debounceDelay);
    }
}